import React, { createContext, useContext, useEffect, useState } from "react";

const AdminAuthContext = createContext();

export const useAdminAuth = () => useContext(AdminAuthContext);

export const AdminAuthProvider = ({ children }) => {
    const [adminData, setAdminData] = useState(() => {
        const storedAdminData = localStorage.getItem("adminData");
        return storedAdminData ? JSON.parse(storedAdminData) : null;
    });

    const isAdminLogged = !!adminData;

    const adminLogin = (data) => {
        setAdminData(data); // Save admin data in the state
        localStorage.setItem("adminData", JSON.stringify(data)); // Persist admin data
    };

    const adminLogout = () => {
        setAdminData(null); // Clear admin data from state
        localStorage.removeItem("adminData"); // Remove admin data from localStorage
    };

    useEffect(() => {
        if (!adminData) {
            localStorage.removeItem("adminData");
        }
    }, [adminData]);

    const value = {
        adminData,
        isAdminLogged,
        adminLogin,
        adminLogout,
    };

    return (
        <AdminAuthContext.Provider value={value}>
            {children}
        </AdminAuthContext.Provider>
    );
};
